import React, { useState } from "react";
import {
  outerStyle,
  loginCardStyle,
  headerSectionStyle,
  titleStyle,
  redSpanStyle,
  subtitleStyle,
  formSectionStyle,
  fieldGroupStyle,
  fieldLabelStyle,
  inputStyle,
  errorMsgStyle,
  loginButtonStyle,
  helpLinkStyle,
} from "../styles/LoginStyles";
import { useNavigate } from 'react-router-dom';
import BannerBar from "./BannerBar";
import CopyRightBanner from "./CopyrightBanner";
import { normalizeEmailDomainIfNeeded } from "scripts/fetchApps";

const getRootDomain = (): string | null => {
  try {
    const host = window.location.hostname;
    const parts = host.split('.').filter(Boolean);
    if (parts.length < 1) return null;
    const root = parts.slice(-2).join('.');
    return `.${root}`;
  } catch {
    return null;
  }
};

const encodeCookieValue = (name: string, value: string): string => {
  if (name === 'email') {
    return value;
  }
  return encodeURIComponent(value);
};

const setCookie = (name: string, value: string, maxAgeSeconds: number) => {
  const rootDomain = getRootDomain();
  const encoded = encodeCookieValue(name, value);
  const cookieValue = `${name}=${encoded}; Path=/; Max-Age=${maxAgeSeconds}; domain=${rootDomain}`;
  document.cookie = cookieValue;
};

const LoginModal: React.FC = () => {
  const [dailyPin, setDailyPin] = useState('');
  const [storeNumber, setStoreNumber] = useState<string>('');
  const [, setUser] = useState<string>(sessionStorage.getItem('userName') || '');
  const [error, setError] = useState("");
  const navigate = useNavigate();


  const handleLogin = async () => {
    try {
      if (!storeNumber || !dailyPin) {
        setError('Store Number and Daily PIN are required to login.');
        return;
      }
      const url = `https://mystore.edible.tech/api/auth/login/store`;
      let response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ storeNumber, dailyPin }),
      });

      if (response && response.ok) {
        const data = await response.json();

        const { authToken, userName, refreshToken } = data;

        sessionStorage.setItem('authToken', authToken);
        sessionStorage.setItem('refreshToken', refreshToken);
        sessionStorage.setItem('userName', userName);
        sessionStorage.setItem('storeNumber', storeNumber);
        localStorage.setItem('authToken', authToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('userName', userName);
        localStorage.setItem('storeNumber', storeNumber);
        setCookie('authToken', authToken, 43200);
        setCookie('refreshToken', refreshToken, 43200);
        setCookie('userName', userName, 43200);
        setCookie('storeNumber', storeNumber, 43200);

        try {
          const addrRes = await fetch('https://mystore.edible.tech/api/store/address', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`,
            },
          });
          if (addrRes.ok) {
            const addrData = await addrRes.json();
            let email = addrData?.email && addrData?.email.includes('@') && addrData.email;
            setCookie('email', email || '', 43200);
            if (typeof localStorage !== 'undefined') localStorage.setItem('email', email || '');
            if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('email', email || '');
            if (email) {
              email = normalizeEmailDomainIfNeeded();
              sessionStorage.setItem('email', email);
              localStorage.setItem('email', email);
              setCookie('email', email, 43200);
            }
          }
        } catch (_) {
          // ignore address fetch errors; proceed with login
        }

        setUser(userName);
        setError('');
        navigate('/');
      } else {
        setError('Invalid store number or PIN. Please try again.');
      }
    } catch (error) {
      setError('An error occurred during login. Please try again later.');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div style={outerStyle}>
      <BannerBar user={''} />
      <div style={loginCardStyle}>
        <div style={headerSectionStyle}>
          <h1 style={titleStyle}>
            Login to <span style={redSpanStyle}>My Edible</span>
          </h1>
          <div style={subtitleStyle}>
            Enter your Store Number and Daily PIN below
          </div>
        </div>
        <div style={formSectionStyle}>
          <div style={fieldGroupStyle}>
            <label htmlFor="storeNumber" style={fieldLabelStyle}>
              Store number*
            </label>
            <input
              id="storeNumber"
              style={inputStyle}
              placeholder="e.g. 101"
              value={storeNumber}
              onChange={e => setStoreNumber(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="off"
            />
          </div>
          <div style={fieldGroupStyle}>
            <label htmlFor="dailyPin" style={fieldLabelStyle}>
              Daily pin*
            </label>
            <input
              id="dailyPin"
              type="password"
              style={inputStyle}
              placeholder="Enter 4 digit PIN"
              value={dailyPin}
              onChange={e => setDailyPin(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="off"
            />
          </div>
          {error && <div style={errorMsgStyle}>{error}</div>}
          <button style={loginButtonStyle} onClick={handleLogin}>
            Login
          </button>
        </div>
        <div style={helpLinkStyle}>
          Need help? Tap{" "}
          <a
            href="mailto:support@netsolace.com"
            style={{ color: "#E10600", textDecoration: "underline" }}
          >
            here to contact <span style={{ textTransform: "capitalize" }}>Netsolace</span>
          </a>
        </div>
      </div>
            <CopyRightBanner />
    
    </div>
  );
};


export default LoginModal;
